import axios from "axios";
import { Message } from "element-ui";
import { getToken, removeToken } from "@/utils/auth";
import router from "@/router/index";

// 统一 axios 实例：baseURL 走环境变量；token 走请求头；401 统一踢回登录页
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 120000,
});

service.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers["token"] = token;
    }

    // GET 对象参数展开为 a[key]=v 形式（与现行后端解析口径一致）
    if (config.method === "get" && config.params) {
      let url = config.url + "?";
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName];
        const part = encodeURIComponent(propName) + "=";
        if (value !== null && typeof value !== "undefined") {
          if (typeof value === "object") {
            for (const key of Object.keys(value)) {
              url +=
                encodeURIComponent(propName + "[" + key + "]") +
                "=" +
                encodeURIComponent(value[key]) +
                "&";
            }
          } else {
            url += part + encodeURIComponent(value) + "&";
          }
        }
      }
      config.url = url.slice(0, -1);
      config.params = {};
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;

    if (res.code != 200) {
      if (res.code == 401) {
        Message({
          message: "token已经失效",
          type: "error",
          duration: 5 * 1000,
        });
        removeToken();
        router.push({ path: "/login" });
      }
      Message({
        message: res.innerMessage || "Error",
        type: "error",
        duration: 5 * 1000,
      });
      return;
    }
    return res;
  },
  (error) => {
    Message({
      message: (error && error.innerMessage) || "网络异常，请稍后重试",
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;
